var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#616161",
    d: "M34.6 28.1H38.6V45.1H34.6z",
    transform: "rotate(-45.001 36.586 36.587)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#616161",
    d: "M20 4A16 16 0 1 0 20 36A16 16 0 1 0 20 4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M36.2 32.1H40.2V44.400000000000006H36.2z",
    transform: "rotate(-45.001 38.24 38.24)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#64B5F6",
    d: "M20 7A13 13 0 1 0 20 33A13 13 0 1 0 20 7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBDEFB",
    d: "M26.9,14.2c-1.7-2-4.2-3.2-6.9-3.2s-5.2,1.2-6.9,3.2c-0.4,0.4-0.3,1.1,0.1,1.4c0.4,0.4,1.1,0.3,1.4-0.1C16,13.9,17.9,13,20,13s4,0.9,5.4,2.5c0.2,0.2,0.5,0.4,0.8,0.4c0.2,0,0.5-0.1,0.6-0.2C27.2,15.3,27.2,14.6,26.9,14.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcons);
export default __webpack_public_path__ + "static/media/search_icons.5b5a18e8aba6281faacc170d2a3c9857.svg";
export { ForwardRef as ReactComponent };